require("./brokerConvenienceTestSubCategories.scss");
const PropTypes = require("prop-types");

// @vendors
const React = require("react");

// @utilities
const classNames = require("classnames");

class BrokerConvenienceTestSubCategories extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { children, activeItem, category, currentStepCategory } = this.props;
        const itemClassNames = (key) => {
            return classNames("convenience-sidebar-subcategories__item", {
                "convenience-sidebar-subcategories__item--active":
                    key<=activeItem && currentStepCategory===category || currentStepCategory > category,
                "convenience-sidebar-subcategories__item--completed":
                    key<=activeItem && currentStepCategory===category  || currentStepCategory > category,
                "convenience-sidebar-subcategories__item--available": true,
            });
        };
        return (
            <ul className={"convenience-sidebar-subcategories__items"}>
                {React.Children.map(children, (child, key) => {
                    return child.type !== 'div' ? (
                        <li className={itemClassNames(key)} key={key}>
                            {React.cloneElement(child, { key })}
                        </li>
                    ) : null;
                })}
            </ul>
        );
    }
}

BrokerConvenienceTestSubCategories.propTypes = {
    children: PropTypes.node,
    activeItem: PropTypes.number,
    category: PropTypes.number,
    currentStepCategory: PropTypes.number,
};

module.exports = BrokerConvenienceTestSubCategories;
